var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component"},[_c('apexchart',{attrs:{"width":"100%","height":'100%',"type":"area","options":_vm.graphOptions,"series":_vm.graphData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }